import React from 'react'
import { useSelector } from 'react-redux'

import { isLoggedIn } from '../store/selectors'

import LoginMenuItem from './LoginMenuItem'
import LogoutMenuItem from './LogoutMenuItem'

const AuthMenuItem = () => {
  const loggedIn = useSelector(isLoggedIn)
  if (loggedIn) {
    return <LogoutMenuItem />
  }
  return <LoginMenuItem />
}

export default AuthMenuItem
